import { render, staticRenderFns } from "./TextCapitalizeIcon.vue?vue&type=template&id=11883ac1&"
import script from "./TextCapitalizeIcon.vue?vue&type=script&lang=js&"
export * from "./TextCapitalizeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports